export const COURSE_UNLOCKING_TYPES = {
    IMMEDIATELY: 1,
    ON_SPECIFIC_DATE: 2,
    POST_START_DAYS: 3,
    POST_PREVIOUS_COMPLETION: 4,
    POST_INSTALLMENTS: 5,
};

export const dateFormats = {
    lockedLesson: "MMM dd, yyyy h:mm a",
};
